import apiBank from '@/api/ecommerce/bank';

const defaultState = () => ({
	listBank: [],
	paginationBank: '',
});

const state = defaultState();

const getters = {

};

const mutations = {
	setBank(state, data) {
		state.listBank = data.data
		state.paginationBank = data.pagination;
	},
	clearDataBank(state) {
		Object.assign(state, defaultState())
	}
};

const actions = {
	getBank({ commit, dispatch }, params) {
		apiBank.getDataBank(params).then(({ data: { data } }) => {
			commit('setBank', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setBank', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
	},
	async exportBank({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiBank.exportBank(params).then(({ data: { data } }) => {
			dispatch('success', data.results.message, { root: true })
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Bank'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async addBank({ dispatch }, params) {
		await dispatch('isAttempting', null, { root: true })
		await apiBank.addBank(params).then(res => {
			const data = res.data;
			dispatch('success', data.message, { root: true })
		}).catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
		await dispatch('attempted', null, { root: true })
	},
	async updateBank({ dispatch }, params) {
		await dispatch('isAttempting', null, { root: true })
		await apiBank.updateBank(params).then(res => {
			const data = res.data;
			dispatch('success', data.message, { root: true })
		}).catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
		await dispatch('attempted', null, { root: true })
	},
	async deleteBank({ dispatch }, params) {
		await dispatch('isAttempting', null, { root: true })
		await apiBank.deleteBank(params).then(res => {
			const data = res.data;
			dispatch('success', data.message, { root: true })
		}).catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
		await dispatch('attempted', null, { root: true })
	},
	getBankAccount({ commit, dispatch }, params) {
		apiBank.getDataBankAccount(params).then(({ data: { data } }) => {
			commit('setBank', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setBank', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
	},
	async exportBankAccount({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiBank.exportBankAccount(params).then(({ data: { data } }) => {
			dispatch('success', data.results.message, { root: true })
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Bank Perusahaan'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async addBankAccount({ dispatch }, params) {
		await dispatch('isAttempting', null, { root: true })
		await apiBank.addBankAccount(params).then(res => {
			const data = res.data;
			dispatch('success', data.message, { root: true })
		}).catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
		await dispatch('attempted', null, { root: true })
	},
	async updateBankAccount({ dispatch }, params) {
		await dispatch('isAttempting', null, { root: true })
		await apiBank.updateBankAccount(params).then(res => {
			const data = res.data;
			dispatch('success', data.message, { root: true })
		}).catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
		await dispatch('attempted', null, { root: true })
	},
	async deleteBankAccount({ dispatch }, params) {
		await dispatch('isAttempting', null, { root: true })
		await apiBank.deleteBankAccount(params).then(res => {
			const data = res.data;
			dispatch('success', data.message, { root: true })
		}).catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
		await dispatch('attempted', null, { root: true })
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};